<template>
  <div class="d-none d-lg-block col-lg-2">
    <div id="menu-right">


      <div class="logoo d-none d-lg-block ">

        <b-col class="text-center">

          <b-icon-person class="img-fluid h1 ml-auto mr-auto rounded text-center rounded-circle "
                         v-if="$store.getters['User/getProfile'].image == null"/>
          <img v-else class="profile-image" :src="$store.getters['User/getProfile'].image" alt="profile">
        </b-col>
        <b-col class="text-center d-print-none mt-3">
          <span>   {{
              `${$store.getters['User/getProfile'].name} ${$store.getters['User/getProfile'].last_name}`
            }}</span>

          <widget-wallet/>

        </b-col>

      </div>
      <nav class="main-nav d-none d-lg-block">
        <ul>
          <item v-for="(item,index) in items"
                :key="index"
                :icon="item.icon"
                :id="item.id"
                :item-class="`${item.name}-${$store.getters['User/isAdmin'] ? 'admin' : 'user'}`"
                :access="item.access"
                :action="item.action"
                :name="item.name"
                :route="item.route"
                :children="item.children"></item>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import Item from './item.vue'
import WidgetWallet from "../Wallet/WidgetWallet";

export default {
  name: "desktop",
  components: {Item, WidgetWallet},
  props: ['items'],
}
</script>

<style scoped>

ul li {
  list-style: none;
}

ul li a:focus {

  color: #7f9afd;

}

ul li a {
  color: #7f807d;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 15px;
  outline: none;
}

.Row {
  width: 30%;
  transition: all 0.5s;
  background: white;
}

.logoo {
  padding-top: 2rem;

}

.img-fluid {
  max-width: 100%;
  height: auto;
  margin-left: 40%;
}


.main-nav {
  padding: 7px 0;
  list-style: none;
}

.profile-image {
  height: 150px;
  width: 150px;
  object-fit: contain;
}

</style>